/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import { without } from 'lodash';
import { SfCompletionCheckListItem } from '../../../resources/lead.model';

@Component({
  standalone: false,
  selector: 'gh-complete-sale-checklist-step',
  templateUrl: 'complete-sale-checklist-step.component.html',
  styleUrls: ['complete-sale-checklist-step.component.scss'],
})
export class CompleteSaleChecklistStepComponent {
  @Input() selected: ID[] = [];
  @Input() checks: SfCompletionCheckListItem[];

  @Output() selectedChange = new EventEmitter<ID[]>();

  isChecked(id: ID): boolean {
    return this.selected.includes(id);
  }

  onCheck(id: ID, checked: boolean): void {
    this.selectedChange.emit(checked ? this.selected.concat(id) : without(this.selected, id));
  }
}
